<template>
    <transition name="slide">
        <router-view>

        </router-view>
    </transition>
</template>

<script>
    export default {
        name: "BaseRequest",
    }
</script>
    
<style scoped>

</style>